export default "__VITE_ASSET__Cs1n$71K__"